/**
 * @desc 保存供需审核
 */
import {
  SupplyDemandEntity,
  SupplyDemandForm
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateSupplyDemandParameter = SupplyDemandForm

const method = 'POST'
const url = '/trade/operation/supplyDemand'

export const createSupplyDemandApi = (
  data?: CreateSupplyDemandParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<SupplyDemandEntity>({
    method,
    url,
    data,
    ...config
  })
}

createSupplyDemandApi.method = method
createSupplyDemandApi.url = url
